export default __webpack_public_path__ + "static/media/silver-frame.87eef594.png";